import { AnimatePresence } from 'motion/react';
import { memo } from 'react';

import { TryCanvasPopoverMobile } from '~/components/TryCanvasPopover/TryCanvasPopoverMobile';
import { useTryCanvasPopoverState } from '~/components/TryCanvasPopover/useTryCanvasPopoverState';

export const TryCanvasPopoverMobileWrapper = memo(() => {
  const { visible, handleClose } = useTryCanvasPopoverState();

  return <AnimatePresence>{visible && <TryCanvasPopoverMobile onClose={handleClose} />}</AnimatePresence>;
});

TryCanvasPopoverMobileWrapper.displayName = 'TryCanvasPopoverMobileWrapper';
